const styleSheet = () => ({
  select: {
    textAlign: 'left',
    boxSizing: 'border-box',
    fontFamily: (props: any) =>
      props.fontOverride || "'Museo Sans', sans-serif",
    display: 'flex',
    border: (props: any) => {
      const { colorOverRide } = props;
      return `1.5px solid ${
        colorOverRide &&
        colorOverRide.close &&
        colorOverRide.close.border &&
        colorOverRide.close.border.color
          ? colorOverRide.close.border.color
          : '#B4CFF7'
      }`;
    },
    borderRadius: '4px',
    fontWeight: 500,
    position: 'relative',
    cursor: 'pointer',
    width: (props: any) => props.width || 'auto',
    fontSize: '12px',
    color: (props: any) =>
      props.colorOverRide &&
      props.colorOverRide.open &&
      props.colorOverRide.open.text &&
      props.colorOverRide.open.text.color
        ? props.colorOverRide.open.text.color
        : '#085FE5',
    padding: '5px 26px 5px 8px',
    backgroundColor: 'transparent',
    appearance: 'none',
  },
  dropdownArrow: {
    position: 'absolute',
    right: '0px',
    top: '1px',
    width: '24px',
    height: '24px',
    marginRight: '1px',
    // "& svg": {}
    '& path': {
      fill: (props: any) => {
        const { colorOverRide } = props;
        return colorOverRide &&
          colorOverRide.open &&
          colorOverRide.open.text &&
          colorOverRide.open.text.color
          ? colorOverRide.open.text.color
          : '#085FE5';
      },
    },
  },
  wrapper: {
    fontFamily: (props: any) =>
      props.fontOverride || "'Museo Sans', sans-serif",
    top: (props: any) => props.top,
    position: 'relative',
    display: 'inline-block',
  },
  optionsHolder: {
    width: '100%',
    right: 0,
    zIndex: 1,
    maxHeight: '300px',
    overflowY: 'auto',
  },
  dropDown: {
    zIndex: 2,
    border: (props: any) => {
      const { colorOverRide } = props;
      return `1.5px solid ${
        colorOverRide &&
        colorOverRide.open &&
        colorOverRide.open.border &&
        colorOverRide.open.border.color
          ? colorOverRide.open.border.color
          : '#B4CFF7'
      }`;
    },
    borderTop: 'none',
    boxSizing: 'border-box',
    backgroundColor: '#ffffff',
    color: (props: any) => {
      const { colorOverRide } = props;
      return colorOverRide &&
        colorOverRide.open &&
        colorOverRide.open.text &&
        colorOverRide.open.text.color
        ? colorOverRide.open.text.color
        : '#085FE5';
    },
  },
  dropDownItem: {
    color: (props: any) => {
      const { colorOverRide } = props;

      return colorOverRide &&
        colorOverRide.open &&
        colorOverRide.open.text &&
        colorOverRide.open.text.color
        ? colorOverRide.open.text.color
        : '#085FE5';
    },
    fontWeight: 500,
    cursor: 'pointer',
    padding: '5px 8px 5px 8px',
    fontSize: '12px',
    textAlign: 'left',
  },
});
export default styleSheet;
